import React from "react";
import { NavLink } from "react-router-dom";
import APSLogo from "../ui/APS Logo.svg";
import {
  LayoutDashboard,
  FileSearch,
  History,
  GitCompare,
  CreditCard,
  User,
  Shield,
  X,
  MessageSquare,
  ListChecks,
} from "lucide-react";

const nav = [
  { label: "Dashboard",      to: "/dashboard",   icon: LayoutDashboard },
  { label: "Analyze Policy", to: "/analyze",      icon: FileSearch },
  { label: "History",        to: "/history",       icon: History },
  // { label: "Changed Report", to: "/change-report",  icon: GitCompare },
  { label: "Scoring Guide",  to: "/scoring-guide", icon: ListChecks },
  { label: "Subscription",   to: "/subscription",  icon: CreditCard },
  { label: "Feedback",       to: "/feedback",     icon: MessageSquare },
  { label: "Profile",        to: "/profile",      icon: User },
];

const Sidebar = ({ onClose }) => {
  return (
  <aside className="w-56 h-full bg-white border-r border-surface-border flex flex-col">
    {/* Logo row */}
    <div className="flex items-center justify-between gap-2.5 px-5 h-16 border-b border-surface-border">
      <div className="flex items-center gap-2.5">
        <img src={APSLogo} alt="APS Logo" className="h-12 w-auto object-contain" />
      </div>
      {/* Close button — mobile only */}
      <button
        onClick={onClose}
        className="lg:hidden text-brand-muted hover:text-brand-text p-1 rounded-lg hover:bg-surface transition-colors"
        aria-label="Close sidebar"
      >
        <X className="w-5 h-5" />
      </button>
    </div>

    {/* Nav links */}
    <nav className="flex flex-col gap-0.5 px-3 pt-4 flex-1 overflow-y-auto">
      {nav.map(({ label, to, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          onClick={onClose}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              isActive
                ? "bg-blue-50 text-primary"
                : "text-brand-muted hover:bg-surface hover:text-brand-text"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon className={`w-4 h-4 flex-shrink-0 ${isActive ? "text-primary" : "text-brand-muted"}`} />
              {label}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  </aside>
  );
};

export default Sidebar;
